import { render, staticRenderFns } from "./VGradeField.vue?vue&type=template&id=6a9a9525&"
import script from "./VGradeField.vue?vue&type=script&lang=js&"
export * from "./VGradeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports